import "./csr.css";
import {Link} from "react-router-dom"
import React, { useState, useEffect, Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Footer from "./footer";
import Chairman from "../images/Chairman.jpg";
import MainBg from "../images/Leadership main bg.jpg";
import men from "../images/men.png";
import Mobilemen from "../images/mobile-men.png"
import Ceo from "../images/Ojiromayo.jpg";
import ED from "../images/Abayomi.jpg";
import Internal from "../images/Yomi.jpg";
import InternalAud from "../images/Segun.jpg";
import RiskMMng from "../images/Kingsley.jpg";
import ready from "../images/avc-ready.jpg";
import benefits from "../images/avc-benefits.jpg";
import csrBanner from "../images/csr-banner.jpg";
import csrStart from '../images/csr-start.png';
import csr1 from '../images/csr-1.png';
import csr2 from '../images/csr-2.png';
import csr3 from '../images/csr-3.png';
import csr4 from '../images/csr-4.png';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { ApolloClient, HttpLink, InMemoryCache, gql } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";
import AOS from 'aos';

const client = new ApolloClient({
  link: new HttpLink({ uri: "https://pensure-cms.inspireleadership.biz/graphql"}),
  cache: new InMemoryCache(),
});

const Csr = () => {

   window.scrollTo(0, 0)
   
        const[heroBanner, setHeroBanner] = useState([])
        const [heroMobile, setHeroMobile] = useState([])
        const [productText, setProductText] = useState("")
        const [productTextContd, setProductTextContd] = useState("")
        const [gallery, setGallery] = useState([])
        const [listSections, setListSections] = useState([])


          useEffect( () => {
                     AOS.init({
                      offset: 0,
                      duration: 1000,
                      once: true
                    });
                  
                      
                  }, [])

     useEffect( () => {
    
    client
      .query({
        query: gql`
      query NewQuery {
  pages {
    edges {
      node {
        id
        socialresponsibility {
          gallery {
            image {
              mediaItemUrl
            }
          }
          hero {
            buttonLink
            buttonName
            caption
            heading
            image {
              mediaItemUrl
            }
          }
          heromobile {
            buttonLink
            buttonName
            caption
            heading
            image {
              mediaItemUrl
            }
          }
          listSection {
            caption
            heading
            image {
              mediaItemUrl
            }
            list {
              item
            }
          }
          productText
          productTextContd
        }
      }
    }
  }
    }
        `,
      })
      .then((result) => {
    
         console.log(result)
          setHeroBanner(result.data.pages.edges[9].node.socialresponsibility.hero)
          setHeroMobile(result.data.pages.edges[9].node.socialresponsibility.heromobile)
           setProductText(result.data.pages.edges[9].node.socialresponsibility.productText)
           setProductTextContd(result.data.pages.edges[9].node.socialresponsibility.productTextContd)
          setGallery(result.data.pages.edges[9].node.socialresponsibility.gallery)
          setListSections(result.data.pages.edges[9].node.socialresponsibility.listSection)
    
    
    
    
      });
    
    }, [])  



       let galleryDisplay
                     
                            let heroBannerDisplay
                             let heroMobileBannerDisplay
                      
                            let listSectionsDisplay
                            
                            
                            
             if(heroBanner.length > 0 ){
              
              heroBannerDisplay = heroBanner.map((banner, i) =>    
                
                        <div className="csr-cover">
          <img className="csr-bg" src={banner.image.mediaItemUrl} />
          <div className="csr-content">
            <div className="csr-txt">
              <h1 className="csr-h1"  data-aos="fade-up" data-aos-delay="200">{banner.heading}</h1>
              <p className="grey-p-csr"  data-aos="fade-up" data-aos-delay="200">
              {banner.caption}         </p>

            </div>
          </div>
        </div>
                
                              )
                            }
                      
           if(heroMobile.length > 0 ){
              heroMobileBannerDisplay = heroMobile.map((banner, i) => 
            
        <div className="csr-cover">
          <img className="csr-bg" src={banner.image.mediaItemUrl} />
          <div className="csr-content">
            <div className="csr-txt">
              <h1 className="csr-h1"  data-aos="fade-up" data-aos-delay="200">{banner.heading}</h1>
              <p className="grey-p-csr"  data-aos="fade-up" data-aos-delay="200">
              {banner.caption}         </p>

            </div>
          </div>
        </div>
                                            
                              )
                     }


             if(gallery.length > 0 ){
                    
              galleryDisplay = gallery.map((banner, i) => 
            
                  <img className="csr-img pb-4" width="" src={csr4}  data-aos="fade-up" data-aos-delay="200" />
                                            
                              )
                            }


   
                               if(listSections.length > 0){ 
      
      
          listSectionsDisplay = listSections.map((section, i) => 

             
      
                    i % 2 ? 


        <div id="mobile-view"  className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5">
                   <div className="d-flex d-none d-sm-block justify-content-end">
                    <img className="img-fluid" src={section.image.mediaItemUrl} />
                  </div>

        <div  className="pension-div1 pb-5">
          <h3 className="rma-h3 pb-5"  data-aos="fade-up" data-aos-delay="200"> {section.heading} </h3>

              <p className="grey-p-pms  pb-4 " style={{ color: "#3B475A", width: "470px" }}  data-aos="fade-up" data-aos-delay="200">
           {section.caption}
          </p>
       
          <hr className="btm-bdr" style={{ borderTop: "none", width: "600px" }} />

          <ul
            className="pt-5 custom-square"
            style={{ listStyleType: "square", paddingLeft: "20px" }}
          >

                {section.list.map( (items,i) => 
                
               <li className="grey-p-rma pt-4" style={{ color: "#3B475A" }}  data-aos="fade-up" data-aos-delay="200">
             {items.item}
            </li>
         

            
            )
            
            }
        
          </ul>
        </div>

         <div className="d-flex d-block d-sm-none justify-content-end">
                    <img className="img-fluid" src={section.image.mediaItemUrl} />
                  </div>
                </div>
        
      
          
          :


  <div id="mobile-view"  className=" d-flex align-items-center justify-content-between pb-5">
              
        <div  className="pension-div1 pb-2">
          <h3 className="rma-h3 pb-2"  data-aos="fade-up" data-aos-delay="200">{section.heading}</h3>

              <p className="grey-p-pms  pb-2 " style={{ color: "#3B475A", width: "470px" }}  data-aos="fade-up" data-aos-delay="200">
            {section.caption}
          </p>

          <hr className="btm-bdr" style={{ borderTop: "none", width: "600px" }} />

          <ul
            className="pt-2 ps-3 custom-square"
            style={{ listStyleType: "square", paddingLeft: "20px" }}
          >

            {section.list.map( (items,i) => 
                
               <li className="grey-p-rma pt-4" style={{ color: "#3B475A" }}  data-aos="fade-up" data-aos-delay="200">
             {items.item}
            </li>
         

            
            )
            
            }

          </ul>
        </div>

             <div className="d-flex justify-content-end">
                    <img className="img-fluid" src={section.image.mediaItemUrl} />
                  </div>

              
                  
                </div>

            
          )
      
        }
              
    

  return (
    <>
      <div className="csr-container d-none d-sm-block">
    {heroBannerDisplay}
      </div>

       <div className="csr-container d-block d-sm-none">
    {heroMobileBannerDisplay}
      </div>

<div className="containeer pt-4">

   <div id="mobile-view" className="d-flex justify-space-between pt-5 padding-section-standard-bottom">
          <div className=" width-fifty">
            <h2 className="csr-h2 pb-4">Our CSR Journey </h2>
          </div>
          <div className=" width-fifty abt-para">
            <p className="grey-p-csr grey-color">
            {productText}  
            
        
            </p>

           <p className="grey-p-csr mt-3 grey-color">
            {productTextContd}  
            
        
            </p>

            <p className="pt-3 grey-p-csr grey-color">

                      </p>
          </div>
  </div>
    


                <div id="mobile-view"  className=" d-flex flex-wrap align-items-center justify-content-between padding-section-standard-top1">
              


                    {galleryDisplay}
                  


                
                                 
                </div>




   {listSectionsDisplay}
                 



      </div>
                 <Footer/>
           <div className='height'> 

              </div>
 
    </>
  );
};

export default Csr;
